(() => {
  function init(root) {
    if (!root || root.dataset.abmrReady) return;
    root.dataset.abmrReady = 'true';

    const slides = [...root.querySelectorAll('.abmr-pdp__slide')];
    const thumbs = [...root.querySelectorAll('[data-abmr-thumb]')];
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      const index = Number(thumb.dataset.abmrThumb);
      slides.forEach((slide) => slide.classList.toggle('is-active', Number(slide.dataset.index) === index));
      thumbs.forEach((item) => {
        const active = item === thumb;
        item.classList.toggle('is-active', active);
        active ? item.setAttribute('aria-current', 'true') : item.removeAttribute('aria-current');
      });
    }));

    const qty = root.querySelector('.abmr-pdp__qty input');
    root.querySelectorAll('[data-abmr-step]').forEach((button) => button.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(button.dataset.abmrStep));
    }));
    qty && qty.addEventListener('change', () => { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });

    const variant = root.querySelector('[data-abmr-variant]');
    const plans = root.querySelector('[data-abmr-plans]');
    let planData = {};
    try { planData = JSON.parse(plans?.querySelector('[data-abmr-plan-data]')?.textContent || '{}'); } catch (e) {}
    const variantId = () => (variant ? variant.value : root.querySelector('input[name="id"]')?.value);

    const sync = () => {
      const data = planData[variantId()];
      const planId = plans?.querySelector('input[name="abmr_purchase"]:checked')?.value || '';
      if (plans) {
        const input = plans.querySelector('[data-abmr-plan-input]');
        input.value = planId;
        input.disabled = !planId;
        plans.querySelectorAll('[data-abmr-plan-price]').forEach((el) => {
          const id = el.dataset.abmrPlanPrice;
          if (data) el.textContent = id ? (data.plans[id] || data.price) : data.price;
        });
      }
      const price = data ? (planId ? data.plans[planId] || data.price : data.price) : variant?.selectedOptions[0]?.dataset.price;
      if (price) root.querySelectorAll('[data-abmr-price]').forEach((el) => { el.textContent = price; });
    };
    variant && variant.addEventListener('change', sync);
    plans && plans.addEventListener('change', sync);
    if (plans) sync();

    const buy = root.querySelector('[data-abmr-buy]');
    const bar = root.querySelector('[data-abmr-sticky]');
    if (buy && bar && 'IntersectionObserver' in window) {
      const button = bar.querySelector('button');
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
        button && (button.tabIndex = show ? 0 : -1);
      }).observe(buy);
    }
  }

  document.querySelectorAll('[data-abmr-pdp]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-abmr-pdp]')));
})();
